import React, { useEffect, useState } from 'react';
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import FileBase64 from 'react-file-base64';
import { Accordion } from 'react-bootstrap';
import { saveInstructor, updateInstructor } from '../../../services/CommonService';

const AddInstructors = ({ tenantprops, updateprop }) => {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [selected, setSelected] = useState([]);
    const options = [
        { label: "tdpyuva", value: "7e71674b" }
    ];

    const fields = {
        position: "",
        status: "",
        name: "",
        title: "",
        description: "",
        githuburl: "",
        linkedinurl: "",
        youtubeurl: "",
        coursescount: "",
        studentscount: "",
        tenant: [],

    }

    const errors = {
        position: "",
        status: "",
        name: "",
        title: "",
        description: "",
        githuburl: "",
        linkedinurl: "",
        youtubeurl: "",
        coursescount: "",
        studentscount: "",

    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);
    const [filefields, setFileFields] = useState(null);
    const [imageshow, setImageShow] = useState(false);
    const [percent, setPercent] = useState(50);


    useEffect(() => {
        //getBanner();

        if (updateprop?.id) {
            setFromFields(updateprop);
            setSelected(updateprop.tenant);
            setFileFields(updateprop.image);
            setImageShow(true);

        }
    }, []);

    const { name, status, position, title, description, linkedinurl, githuburl, youtubeurl, coursescount, studentscount } = formfields;

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;



        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter  name .";
        }

        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }
        if (!fields["title"]) {
            formIsValid = false;
            errors["title"] = "*Please enter title .";
        }
        if (!fields["description"]) {
            formIsValid = false;
            errors["description"] = "*Please enter description .";
        }

        if (filefields == null) {
            errors["base64"] = "*Please choose image .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    function handleChangeFile(files) {
        setFileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setFileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setImageShow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    const submitForm = async () => {
        const isValid = await validateForm();
        if (isValid) {
            formfields.tenant = selected;
            formfields.image = filefields;
            if (!formfields.id) {
                //save
                const Response = await saveInstructor(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update
                const Response = await updateInstructor(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }




    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="row">
                <div className="form-group mb-3 col-md-6">
                    <label
                    >
                        Position
                    </label>
                    <input component="input"
                        placeholder="position"
                        name="position"
                        className="form-control"
                        value={position} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.position}</div>
                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Title
                    </label>
                    <input component="input"
                        placeholder="title"
                        name="title"
                        className="form-control"
                        value={title} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.title}</div>
                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Tenants
                    </label>
                    <MultiSelect
                        options={tenantprops}
                        value={selected}
                        onChange={setSelected}
                        labelledBy="Select"
                    />

                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Instructor Name
                    </label>
                    <input component="input"
                        placeholder="Instructor name"
                        name="name"
                        className="form-control"
                        value={name} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.name}</div>
                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Description
                    </label>
                    <textarea
                        rows={4}
                        className="form-control"
                        name="description"
                        placeholder="description"
                        id="comment"
                        onChange={handleChange}
                        value={description}
                    />

                    <div className="errorMsg">{errorFields.description}</div>
                </div>


                <div className="form-group mb-3 col-md-6">
                    <label
                    >
                        Github url
                    </label>
                    <input component="input"
                        placeholder="githuburl"
                        name="githuburl"
                        className="form-control"
                        value={githuburl} maxLength={50} onChange={handleChange} />

                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Youtube url
                    </label>
                    <input component="input"
                        placeholder="youtubeurl"
                        name="youtubeurl"
                        className="form-control"
                        value={youtubeurl} maxLength={50} onChange={handleChange} />

                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Linkedin url
                    </label>
                    <input component="input"
                        placeholder="linkedinurl"
                        name="linkedinurl"
                        className="form-control"
                        value={linkedinurl} maxLength={50} onChange={handleChange} />

                </div>

                <div className="form-group mb-3 col-md-6">
                    <label
                    >
                        Courses count
                    </label>
                    <input component="input"
                        placeholder="coursescount"
                        name="coursescount"
                        className="form-control"
                        value={coursescount} maxLength={50} onChange={handleChange} />

                </div>

                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Students count
                    </label>
                    <input component="input"
                        placeholder="studentscount"
                        name="studentscount"
                        className="form-control"
                        value={studentscount} maxLength={50} onChange={handleChange} />

                </div>



                <div className="form-group mb-3 col-md-6">
                    <label

                    >
                        Status
                    </label>
                    <select
                        className="form-control" name='status'
                        onChange={handleChange} value={status}>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>

                    <div className="errorMsg">{errorFields.status}</div>
                </div>
            </div>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Add Image
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">

                            <div className="form-group mb-3 row">
                                <label
                                    className="col-lg-4 col-form-label"
                                    htmlFor="val-username"
                                >
                                    Image (1020w * 680h)
                                </label>
                                <div className="custom-file">
                                    <FileBase64
                                        multiple={true}
                                        onDone={handleChangeFile} />
                                </div>
                                <div className="errorMsg">{errorFields.base64}</div>
                            </div>

                            {imageshow && <> <div className="form-group mb-3 row">
                                <label
                                    className="col-lg-4 col-form-label"
                                    htmlFor="val-username"
                                >
                                    Uploaded Image
                                </label>
                                <img src={filefields} alt="Red dot" />

                            </div> </>}

                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>

            <div className="form-group">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>
        </>
    )

}

export default AddInstructors